import * as React from 'react';

import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { VehicleData } from '../../data/VehicleData';
import { Typography } from '@mui/material';

const filter = createFilterOptions();

export default function SearchVRM({setAllValue, getOwner, setOwnerData, setOwnerValue, inputRef}) {

  const [value, setValue] = React.useState(null);
  const [open, toggleOpen] = React.useState(false);

  const handleClose = () => {
    setDialogValue({
      title: '',
      year: '',
    });
    toggleOpen(false);
  };

  const [dialogValue, setDialogValue] = React.useState({
    title: '',
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    setValue({
      title: dialogValue.title,
      year: parseInt(dialogValue.year, 10),
    });
    handleClose();
  };

  return (
    <>
      <Autocomplete
        size='small'
        fullWidth
        value={value}
        onChange={(event, newValue) => {
          setOwnerData(null)
          setOwnerValue(null)
          if (typeof newValue === 'string') {
            // timeout to avoid instant validation of the dialog's form.
            setTimeout(() => {
              toggleOpen(true);
              setDialogValue({
                title: newValue,
                year: '',
              });
            });
          } else if (newValue && newValue.inputValue) {
            setValue(newValue.inputValue)
            toggleOpen(true);
            setDialogValue({
              title: newValue.inputValue,
            });
          } else {
            getOwner(newValue?.id? newValue.id : '', newValue)
            setAllValue(newValue)
            setValue(newValue);
          }
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);
          if (params.inputValue !== '') {
            filtered.push({
              inputValue: params.inputValue,
              VRM: `Search "${params.inputValue}"`,
            });
          }
          return filtered;
        }}
        id="free-solo-dialog-demo"
        options={VehicleData}
        getOptionLabel={(option) => {
          // e.g. value selected with enter, right from the input
          if (typeof option === 'string') {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return option.VRM;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        renderOption={(props, option) => <li {...props}>{option.VRM}</li>}
        freeSolo
        renderInput={(params) => <TextField {...params} label="Registration No" inputRef={inputRef} />}
      />
      <Dialog open={open} onClose={handleClose}>
        <form >
          <DialogTitle>Search Vehicle</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Vehicle Number
            </DialogContentText>
            <Typography>{dialogValue.title}</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit">Add</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}